import { Grid } from "@mui/material";
import { memo } from "react";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { useFormValidationsDocumentsMsgSlice } from "../../../store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import MxFormSubTitleAndDescription from "@rf-l1/page/form/MxFormSubTitleAndDescription";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import { CDocumentKeys } from "../../../util/model/documents-types";
import useRevalidateDocumentDeps from "../../../hooks/useRevalidateDocumentDeps";

const DocumentsDataFormSection = () => {
  useRevalidateDocumentDeps();
  const {
    validationDocuments: { property_contract }
  } = useFormValidationsDocumentsMsgSlice();

  const { showNotification } = useShowValidationInfo();

  // Wrappers de subida inmediata por documento

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MxFormSubTitleAndDescription
          label="Documentos"
          description="Los formatos de archivo permitidos son PDF, JPG, JPEG y PNG, con un tamaño máximo de 3 MB y 7 MB."
        />
      </Grid>

      <Grid container item xs={12} md={10} lg={10} spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <MxFormL4DocumentFileProperty
            withreacthookform={1}
            name={CPropertyFormKeys.file_capture_details_property}
            label="Detalle de captación"
            minSize={0}
            maxSize={3}
            typeKey={CDocumentKeys.CaptureDetails}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <MxFormL4DocumentFileProperty
            withreacthookform={1}
            name={CPropertyFormKeys.file_owner_id_property}
            label="Cédula de propietario(s)"
            minSize={0}
            maxSize={3}
            typeKey={CDocumentKeys.OwnerId}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <MxFormL4DocumentFileProperty
            withreacthookform={1}
            name={CPropertyFormKeys.file_application_form_property}
            label="Formulario de captación"
            minSize={0}
            maxSize={3}
            typeKey={CDocumentKeys.CaptureForm}
          />
        </Grid>
      </Grid>

      <Grid container item xs={12} md={10} lg={10} spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <MxFormL4DocumentFileProperty
            withreacthookform={1}
            name={CPropertyFormKeys.file_power_ownership_property}
            label="Poder de propiedad"
            minSize={0}
            maxSize={3}
            typeKey={CDocumentKeys.PropertyPower}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <MxFormL4DocumentFileProperty
            withreacthookform={1}
            name={CPropertyFormKeys.file_commercial_registry_property}
            label="Registro Mercantil"
            minSize={0}
            maxSize={3}
            typeKey={CDocumentKeys.MercantileRegistry}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <MxFormL4DocumentFileProperty
            withreacthookform={1}
            name={CPropertyFormKeys.file_property_contract_property}
            label="Contrato de propiedad"
            minSize={0}
            maxSize={7}
            disabled={property_contract.disabled}
            typeKey={CDocumentKeys.PropertyContract}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(DocumentsDataFormSection);
